import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=f00fd8e0&scoped=true&"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./confirmation-modal.scss?vue&type=style&index=0&id=f00fd8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00fd8e0",
  null
  
)

export default component.exports